module.exports = __webpack_public_path__ + "static/media/hero_large.4271dfa6.jpg";